module.exports = __webpack_public_path__ + "img/8191147.ec8c2232.png";